import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Title = styled.h2<{ noBorder?: boolean }>`
    margin: 0 0 ${theme.space[3] / 2}px;
    padding: ${theme.space[3] / 2}px 0;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
    line-height: 2rem;
    text-transform: uppercase;
    color: ${theme.colors.primaryBlack};
    border-bottom: 1px solid ${theme.colors.grey2};

    ${({ noBorder }) =>
        noBorder &&
        css`
            padding-bottom: 0;
            border-bottom: none;
        `};
`;

export const Description = styled.p`
    margin: 0 0 ${theme.space[3] / 2}px;
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.primaryBlack};
`;

export const Card = styled.div`
    padding: ${theme.space[3] / 2}px ${theme.space[2]}px;
    background-color: ${theme.colors.grey1};
    border: 1px solid ${theme.colors.grey3};
`;

export const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: ${theme.space[3] / 2}px;
    border-bottom: 1px solid ${theme.colors.grey2};
`;

export const RemoveButton = styled.button``;
